import moment from 'moment';

export interface Report {
    id: number;
    fechaCreado: string;
    // fechaDesde: string;
    // fechaHasta: string;
    motivo: string;
    comentado: boolean;
    concepto: string;
    estado: string;
    estadoClase: string;
    caseID: string;
    contactID: string;
    descripcion: string;
    email: string;
    nombre: string;
    albaran: string;
    factura: string;
    pedido: string;
    promocion: string;
    resolucion: string;
    uri: string;
    dirEnvio: number;
}

export class ReportHelper {
    private static normalizeText(value: string): string {
        return value
            ? value
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
            : '';
    }

    static create(): Report {
        return {
            id: undefined,
            fechaCreado: undefined,
            // fechaDesde: undefined,
            // fechaHasta: undefined,
            motivo: undefined,
            comentado: undefined,
            concepto: undefined,
            estado: undefined,
            estadoClase: undefined,
            caseID: undefined,
            contactID: undefined,
            descripcion: undefined,
            email: undefined,
            nombre: undefined,
            albaran: undefined,
            factura: undefined,
            pedido: undefined,
            promocion: undefined,
            resolucion: undefined,
            uri: undefined,
            dirEnvio: -1
        };
    }

    static transformFromApi(apiData: Object): Report {
        const offsetUtc = moment().utcOffset();
        const report = ReportHelper.create();
        report.id = apiData['Ticket_Id'] ? apiData['Ticket_Id'] : '';
        report.fechaCreado = apiData['Created_Time']
            ? moment.utc(apiData['Created_Time']).utcOffset(offsetUtc).toString()
            : '';
        report.motivo = ReportHelper.normalizeText(apiData['Motivo'] ? apiData['Motivo'] : '');
        report.comentado = apiData['IsCommented'] ? apiData['IsCommented'] : '';
        report.concepto = apiData['Subject'] ? apiData['Subject'] : '';
        report.estado = apiData['Status'] ? apiData['Status'] : '';
        switch (report.estado) {
            case 'En Gestión':
            case 'Pendiente Respuesta':
            case 'Pendiente Gestión Interna':
                report.estadoClase = 'bg-warning-light text-warning';
                break;
            case 'Closed':
                report.estadoClase = 'bg-success text-white';
                break;
            default:
                report.estadoClase = 'bg-featured text-featured';
        }
        report.nombre = apiData['Contact_Name'] ? apiData['Contact_Name'] : '';
        report.caseID = apiData['CASEID'] ? apiData['CASEID'] : '';
        report.contactID = apiData['CONTACTID'] ? apiData['CONTACTID'] : '';
        report.descripcion = apiData['Description'] ? apiData['Description'] : '';
        report.email = apiData['Email'] ? apiData['Email'] : '';
        report.albaran = apiData['Numero_Albarán'] ? apiData['Numero_Albarán'] : '';
        report.factura = apiData['Numero_Factura'] ? apiData['Numero_Factura'] : '';
        report.pedido = apiData['Numero_Pedido'] ? apiData['Numero_Pedido'] : '';
        report.promocion = apiData['Numero_Promocion'] ? apiData['Numero_Promocion'] : '';
        report.resolucion = apiData['Resolution'] ? apiData['Resolution'] : '';
        report.uri = apiData['URI'] ? apiData['URI'] : '';
        report.dirEnvio = apiData['DirEnvio'] !== undefined ? Number(apiData['DirEnvio']) : -1;

        return report;
    }
}
